var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalysisRequests',{attrs:{"siteId":_vm.site.id},on:{"onTemplate":_vm.openTemplateModal}})}
var staticRenderFns = []

export { render, staticRenderFns }